import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import InlineEditor from '@/agilis/components/InlineEditor/InlineEditor.vue'
import jsonLogic from '@/plugins/jsonLogic'
import FormSelect from '@/agilis/components/Form/FormSelect/FormSelect.vue'
import L from 'lodash'

export default {
  name: 'SplittingDialog',

  props: {
    configuration: Object,
    fetchData: {
      type: Function,
      default: null
    },
    itemDTO: Object,
    items: Array,
    wpGroups: Array,
    splitDialog: Boolean
  },

  components: {
    InlineEditor,
    FormSelect
  },
  data () {
    return {
      dialog: this.splitDialog,
      originalItem: [this.itemDTO],
      splittedItems: []
    }
  },

  watch: {
    dialog (newValue) {
      if (newValue === true) {
        this.getWorkPackage3()
        if (this.items.filter(item => item.wpPropositionId === this.itemDTO.wpPropositionId).length === 1) {
          this.splittedItems = []
        } else {
          let id = 0
          this.splittedItems = L.cloneDeep(this.items.filter(item => item.wpPropositionId === this.itemDTO.wpPropositionId)
            .map(item => {
              item._id = id += 1
              return item
            }))
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      selectedContext: 'contextStore/selectedContext'
    }),
    headers () {
      return Configuration.datatable.getHeaders(this.configuration)
    },
    jlContext () {
      return {
        itemDTO: this.originalItem[0],
        items: this.splittedItems
      }
    },
    title () {
      return this.$t(this.configuration.title, this.jlContext.itemDTO)
    },
    originalSplitItem () {
      const splitItem = L.cloneDeep(this.originalItem[0])
      splitItem['wpPropositionId'] = splitItem.id
      splitItem['workPackage3'] = { 'id': splitItem.id }
      splitItem['deliveryGroup'] = { 'id': this.itemDTO.deliveryGroupId }
      splitItem._id = this.splittedItems.length > 0 ? this.splittedItems.reduce((p, c) => p._id > c._id ? p : c)._id + 1 || 1 : 1
      splitItem.id = null
      return splitItem
    },
    validationLogic () {
      const validationLogic = this.configuration?.validationLogic?.jsonLogic
      return validationLogic ? jsonLogic.apply(validationLogic, this.jlContext) : false
    },
    existingItems () {
      if (this.splittedItems.length === 0) {
        return this.items.slice(0)
      }
      const filteredExistingItems = this.items.filter(item => item.id !== this.itemDTO.id)
      return L.concat(filteredExistingItems, this.splittedItems)
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),
    headerType (header) {
      return this.configuration.columns[header.value]?.type
    },
    configHeader (header) {
      let config = this.configuration.columns[header.value]
      if (header.value === 'deliveryGroup') {
        config.options = this.wpGroups
      }
      return config
    },
    triggerValidation () {
      let lastSplitItemFieldsValues = {}
      this.$refs.inlineEditor.forEach((inlineInput) => {
        lastSplitItemFieldsValues[inlineInput.$attrs.name] = inlineInput
      })
      Object.values(lastSplitItemFieldsValues).forEach(field => {
        if (Configuration.datatable.hasValidationRules(field)) {
          field.toggleEdit()
        }
      })
    },
    async waitForRefs () {
      const refsAvailable = () => {
        return this.$refs?.inlineEditor && this.$refs.inlineEditor.length > 0
      }

      while (!refsAvailable()) {
        await new Promise(resolve => setTimeout(resolve, 50))
      }
    },
    addItem () {
      this.splittedItems.push(L.cloneDeep(this.originalSplitItem))
      this.waitForRefs().then(() => {
        this.triggerValidation()
      })
    },
    deleteItem (_item) {
      this.splittedItems = this.splittedItems.filter(item => item._id !== _item._id)
    },
    inlineEditItem (_item, newValue, colConfig) {
      if (_item[colConfig.id] !== newValue) {
        let splitItemIndex = this.splittedItems.findIndex(item => item._id === _item._id)
        let splitItem = this.splittedItems[splitItemIndex]
        switch (colConfig.type) {
          case 'select':
            splitItem[colConfig.id] = newValue[colConfig.id]
            break
          default: splitItem[colConfig.id] = newValue
        }
        Vue.set(this.splittedItems, splitItemIndex, splitItem)
        return splitItem
      }
    },
    renderColumn (colConfig, item) {
      return Configuration.datatable.renderColumn(colConfig, item)
    },
    split (items) {
      if (items.length === 0) {
        items.push(L.cloneDeep(this.originalSplitItem))
      }
      const url = this.$axios.agilisUrlDeliveryGroupV2WpSplit(
        this.selectedContext.applicationId,
        this.selectedContext.trackerTypeId,
        this.selectedContext.trackerId,
        items[0].wpPropositionId)
      this.$axios
        .put(url, items, this.$axios.agilisRequestConfig(url))
        .then(() => {
          this.fetchData()
        })
        .catch((error) => {
          this.notifyError(error)
        })
        .finally(() => {
          this.closeDialog()
        })
    },
    getWorkPackage3 () {
      const url = this.$axios.agilisUrlWorkPackage3(
        this.itemDTO.propositionId,
        this.itemDTO.wpPropositionId)
      this.$axios
        .get(url, this.$axios.agilisRequestConfig(url))
        .then((response) => {
          this.originalItem = [Object.assign({}, response.data)]
        })
        .catch((error) => {
          this.notifyError(error)
        })
    },
    closeDialog () {
      this.dialog = false
    }
  }
}
